import { render, staticRenderFns } from "./EventWaitlistRegistrationsComponent.vue?vue&type=template&id=19c78a4f&scoped=true&"
import script from "./EventWaitlistRegistrationsComponent.vue?vue&type=script&lang=js&"
export * from "./EventWaitlistRegistrationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c78a4f",
  null
  
)

export default component.exports